export interface FlavorSpot {
  id: string;
  city: string;
  cityEn: string;
  dish: string;
  place: string;
  wish: string;
  character: string;
  x: number;
  y: number;
}

export const flavorSpots: FlavorSpot[] = [
  {
    id: 'beijing',
    city: '北京',
    cityEn: 'BEIJING',
    dish: '北京烤鸭',
    place: '皇城胡同 · 讲究与热闹',
    wish: '圆满 · 富足',
    character: '鸭珑珑',
    x: 58,
    y: 27,
  },
  {
    id: 'xian',
    city: '西安',
    cityEn: "XI'AN",
    dish: '腊汁肉夹馍',
    place: '长安城墙 · 千年烟火',
    wish: '踏实 · 饱足',
    character: '馍圆圆',
    x: 45,
    y: 40,
  },
  {
    id: 'chengdu',
    city: '成都',
    cityEn: 'CHENGDU',
    dish: '甜水面',
    place: '天府平原 · 闲适安逸',
    wish: '长久 · 康健',
    character: '面长长',
    x: 34,
    y: 53,
  },
  {
    id: 'chongqing',
    city: '重庆',
    cityEn: 'CHONGQING',
    dish: '麻辣火锅',
    place: '山城江湖 · 热辣直爽',
    wish: '红火 · 热闹',
    character: '辣墩墩',
    x: 43,
    y: 56,
  },
  {
    id: 'hangzhou',
    city: '杭州',
    cityEn: 'HANGZHOU',
    dish: '西湖醋鱼',
    place: '江南烟雨 · 温柔松弛',
    wish: '好运 · 好生活',
    character: '鱼豆豆',
    x: 63,
    y: 51,
  },
  {
    id: 'guangdong',
    city: '广东',
    cityEn: 'GUANGDONG',
    dish: '早茶虾饺',
    place: '岭南水乡 · 一盅两件',
    wish: '团圆 · 聚首',
    character: '虾饺饺',
    x: 55,
    y: 78,
  },
];